import { Skeleton } from "@/components/ui/skeleton";

const NewsCardSkeleton = () => {
  return (
    <div className="modern-card overflow-hidden">
      {/* Image skeleton */}
      <Skeleton className="w-full aspect-[16/10] rounded-none" />
      
      {/* Content */}
      <div className="p-8">
        {/* Meta */}
        <div className="flex items-center gap-3 mb-4">
          <Skeleton className="h-3 w-16" />
          <Skeleton className="h-1 w-1 rounded-full" />
          <Skeleton className="h-3 w-20" />
        </div>
        
        {/* Title */}
        <Skeleton className="h-6 w-full mb-2" />
        <Skeleton className="h-6 w-2/3 mb-3" />
        
        {/* Excerpt */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-4/5" />
        </div>
      </div>
    </div>
  );
};

export default NewsCardSkeleton;
